import {Attrs, MinzeElement, Reactive} from "minze";

export interface TjPlusIcon {
  dataDisabled?: boolean
}

export class TjPlusIcon extends MinzeElement {
  attrs: Attrs = ["data-disabled"]
  reactive: Reactive = [["disabled", this.dataDisabled || false]];

  static observedAttributes = ["data-disabled"]

  onAttributeChange = (name: string) => {
    if (name === "data-disabled") {
      this.disabled = this.dataDisabled || false
    }
  };

  html = () => `
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_1965_885)">
        <path d="M10.2426 6H1.75736" stroke="${this.dataDisabled ? "#878787" : "#133762"}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6 1.75736V10.2426" stroke="${this.dataDisabled ? "#878787" : "#133762"}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1965_885">
          <rect width="12" height="12" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  `;

  css = () => `
    
  `;
}
